module.exports = __webpack_public_path__ + "assets/9d17a59ebbe4f2f7e611fcaa6947f65b.mp3";